/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Who_Pr_4Inputs */

const en_fc_vs_who_pr_4 = /** @type {(inputs: Fc_Vs_Who_Pr_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`need to edit on a phone or tablet`)
};

/**
* | output |
* | --- |
* | "need to edit on a phone or tablet" |
*
* @param {Fc_Vs_Who_Pr_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_who_pr_4 = /** @type {((inputs?: Fc_Vs_Who_Pr_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Who_Pr_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_who_pr_4(inputs)
});
export { fc_vs_who_pr_4 as "fc.vs.who.pr.4" }